import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CompanyDocument } from '../types';
import { PickedItem } from 'src/data-capture/file-management/drop-zone/SharePointButton';

type OneDriveFileItem = {
  fileName: string;
  downloadUrl: string;
  fileSize?: number;
};

type CreateOneDriveCompanyDocumentRequest = {
  files: OneDriveFileItem[];
};

export const useOneDriveCompanyDocumentUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const queryClient = useQueryClient();

  const uploadOneDriveFiles = async (items: PickedItem[]): Promise<CompanyDocument[]> => {
    try {
      setIsUploading(true);
      const files: OneDriveFileItem[] = items
        .filter(item => item.name && item.downloadUrl)
        .map(item => ({
          fileName: item.name!,
          downloadUrl: item.downloadUrl!,
          fileSize: item.size,
        }));

      const response = await api.post<CompanyDocument[]>('company-documents/onedrive', {
        files,
      } satisfies CreateOneDriveCompanyDocumentRequest);

      await queryClient.invalidateQueries({ queryKey: ['company-documents'] });

      return response.data;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadOneDriveFiles,
    isUploading,
  };
};
